// extracted by mini-css-extract-plugin
export var actionIcon = "_kz-0";